import { render } from "./SendDeliveryShippingList.vue?vue&type=template&id=2be7bc9b&scoped=true"
import script from "./SendDeliveryShippingList.vue?vue&type=script&lang=js"
export * from "./SendDeliveryShippingList.vue?vue&type=script&lang=js"

import "./SendDeliveryShippingList.vue?vue&type=style&index=0&id=2be7bc9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be7bc9b"]])

export default __exports__